<template>
  <div class="side-bar">
    <!-- <div class="refresh-cnt">
      <el-tooltip
        effect="dark"
        :content="$t('sideBar.refresh')"
        placement="bottom"
        popper-class="header-tips"
      >
        <i class="el-icon-refresh refresh" @click="refresh"></i>
      </el-tooltip>
    </div> -->
    <el-menu background-color="#333"
             text-color="#fff"
             :collapse-transition="true"
             active-text-color="#3F9EFF"
             class="el-menu-vertical-sidebar"
             :collapse="isCollapse"
             :router="true"
             :default-active="activeUrl"
             v-loading="loading"
             :element-loading-text="$t('sideBar.tips1')">
      <el-submenu :index="`${item.id}`"
                  v-for="item in list"
                  :key="item.id">
        <div slot="title"
             class="t1">
          <i :class="{ [item.icon]: true }"
             class="iconfont mr-8"></i>
          <span slot="title"> {{ item.name }}</span>
          <!-- TODO:目前直接减少左侧菜单的长度，后期字段过长，可进行对应放开 -->
          <!-- <div v-if="isLengthToLong(item.name).isLong"
               slot="title"><span>{{ item.name }}</span></div>
          <div slot="title"
               style="width: 100%; height: 56px;"
               v-else>
            <el-tooltip placement="right"
                        width="200"
                        trigger="hover"
                        :content="isLengthToLong(item.name).long">
              <span>{{ isLengthToLong(item.name).short }}</span>
            </el-tooltip>
          </div> -->
        </div>
        <!-- <el-menu-item-group> -->
        <el-menu-item :index="subItem.path"
                      v-for="subItem in item.children"
                      :key="subItem.id"
                      v-show="subItem.isShow">
          <span>
            <i :class="{ [subItem.icon]: true }"
               class="iconfont mr-4"></i>
            {{ subItem.name }}
          </span>
        </el-menu-item>
        <!-- </el-menu-item-group> -->
      </el-submenu>
      <div class="switch"
           v-bind:style="{ width: isCollapse ? '64px' : '200px' }">
        <div class="line">
          <i v-bind:class="[isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold', 'collapse']"
             @click="changeCollapse"></i>
        </div>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { freshAuth } from "@/api/api.js";
import { menuDetails } from "@/utils/menuDetails";
export default {
  data() {
    return {
      activeUrl: "",
      isCollapse: false,
      list: [],
      loading: false
    };
  },
  methods: {
    // isLengthToLong(str) {
    //   let isLong = false;
    //   if (str.length > 15) isLong = true;
    //   let obj = {
    //     long: str,
    //     short: str.substring(0, 13) + "...",
    //     ifLong: isLong
    //   };
    //   return obj;
    // },
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    async refresh() {
      this.loading = true;
      await freshAuth();
      await this.routeList();
      this.loading = false;
    },
    ...mapActions(["routeList"])
  },
  computed: {
    ...mapGetters(["sideBarList", "sideBarListEN", "lang"])
  },
  watch: {
    lang: {
      handler(newValue) {
        switch (newValue) {
          case "en_us":
            this.list = this.sideBarListEN || [];
            break;
          default:
            this.list = this.sideBarListEN || [];
            break;
        }
      },
      immediate: true
    },
    "$route.path": {
      handler(newValue) {
        this.activeUrl = menuDetails(newValue);
      },
      immediate: true
    }
  }
};
</script>
<style lang="less">
.side-bar {
  .el-menu-vertical-sidebar:not(.el-menu--collapse) {
    width: 200px;
    height: 100%;
    overflow: auto;
  }
  .el-menu {
    border-right: none !important;
  }
  .el-menu-item * {
    vertical-align: inherit;
  }
  .el-submenu__icon-arrow {
    margin-top: -5px;
  }
  /* a.router-link-active .el-menu-item {
  color: #409eff !important;
}
a.router-link-active .el-menu-item i {
  color: #409eff !important;
} */
}
</style>
<style lang="less" scoped>
.t1 {
  display: flex;
  // align-items: baseline;
}
.switch {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 200px;
  height: 56px;
  .line {
    height: 30px;
    border-top: 1px solid #909399;
    padding-top: 15px;
    margin-left: 18px;
    margin-right: 18px;
    i {
      float: right;
    }
  }
}
.side-bar {
  position: relative;
  overflow: hidden;
  height: 100%;
  background: #333;
  .collapse {
    font-size: 30px;
    color: #fff;
    cursor: pointer;
  }
}
.refresh-cnt {
  display: flex;
  justify-content: flex-end;
  padding-right: 18px;
}
.refresh {
  font-size: 24px;
  color: #fff;
}
</style>
